import { emailService } from "../axios";

export const sendEmailStarted = (data) => {
  return {
    type: "SEND_EMAIL_STARTED",
    data: data,
  };
};

export const sendEmailSuccess = (data) => {
  return {
    type: "SEND_EMAIL_SUCCESS",
    data: data,
  };
};

export const sendEmailFailure = (error) => {
  console.log("Unable to send email data", error);
  return {
    type: "SEND_EMAIL_FAILURE",
    data: error,
  };
};

export const sendDonorThankYouEmail = (data) => {
  return (dispatch) => {
    dispatch(sendEmailStarted(data));
    return emailService
      .post("/donorThankYouEmail", data)
      .then((response) => {
        dispatch(sendEmailSuccess(response));
      })
      .catch((error) => {
        dispatch(sendEmailFailure(error));
      });
  };
};

export const sendDonationNotificationEmail = (data) => {
  return (dispatch) => {
    dispatch(sendEmailStarted(data));
    return emailService
      .post("/donationNotificationEmail", data)
      .then((response) => {
        dispatch(sendEmailSuccess(response));
      })
      .catch((error) => {
        dispatch(sendEmailFailure(error));
      });
  };
};

export const sendTeamCreatedEmail = (data) => {
  return (dispatch) => {
    dispatch(sendEmailStarted(data));
    return emailService
      .post("/teamCreatedEmail", data)
      .then((response) => {
        dispatch(sendEmailSuccess(response));
      })
      .catch((error) => {
        dispatch(sendEmailFailure(error));
      });
  };
};

export const sendPinnacleMessage = (data) => {
  return (dispatch) => {
    dispatch(sendEmailStarted(data));
    return emailService
      .post("/pinnacleMessageEmail", data)
      .then((response) => {
        dispatch(sendEmailSuccess(response));
      })
      .catch((error) => {
        dispatch(sendEmailFailure(error));
      });
  };
};

export const sendLeaderboardRankIncrease = (data) => {
  return (dispatch) => {
    dispatch(sendEmailStarted(data));
    return emailService
      .post("/leaderboardRankIncrease", data)
      .then((response) => {
        dispatch(sendEmailSuccess(response));
      })
      .catch((error) => {
        dispatch(sendEmailFailure(error));
      });
  };
};

export const sendLeaderboardRankDecrease = (data) => {
  return (dispatch) => {
    dispatch(sendEmailStarted(data));
    return emailService
      .post("/leaderboardRankDecrease", data)
      .then((response) => {
        dispatch(sendEmailSuccess(response));
      })
      .catch((error) => {
        dispatch(sendEmailFailure(error));
      });
  };
};
